import { useOrgValue } from 'hooks/business/system/useOrg';
import type { OrgValue } from 'hooks/business/system/useOrg';

export const useHisenseFeature = () => {
  const orgValue = useOrgValue();
  return isHisense(orgValue);
};

export const isHisense = (orgValue?: OrgValue) => {
  if (import.meta.env.VITE_ENV === 'staging' || import.meta.env.VITE_ENV === 'feature') {
    return localStorage.getItem('hisense') === 'true';
  }
  return orgValue?.orgId === 8554;
};
